"use client"

import Link from "next/link"
import { ArticleListType, CatType } from "./ArticleListView"
import Image from "next/image"
import { ConvertLink } from "@/util/tools"
import { imageUrl } from "@/util/api/baseUrl"
import PaginationView from "@/util/view/PaginationView"
import { PersianNum } from "@/util/tools/PersianNum"
interface Data {
    id: number;
    cat_title: string;
    cat_url: string;
    cat_description: string;
    cat_image: string;
    cat_image_alt: string;
    cat_title_seo: string;
    cat_description_seo: string;
    cat_image_seo: string;
    cat_type: string;
    cat_parent: number;
    cat_status: number;
    cat_canonical: string;
    cat_keyword: string;
    createdAt: Date;
    updatedAt: Date;
}


const BlogView = ({ data, dataCat }: { data: ArticleListType, dataCat: Data }) => {
    return (
        <div className="py-5">
            <div className="border my-10">
                <h1 className="text-center my-2 font-bold text-text text-2xl">
                    {dataCat?.cat_title}
                </h1>
                <h2 className="text-center my-2 border-b border-pink text-text">{dataCat.cat_description_seo}</h2>
                <div className="p-2 flex flex-wrap sm:justify-between justify-center items-center">
                    {
                        data?.data?.rows.map((article) =>
                            <div key={article.id} className="md:w-1/4 sm:w-1/2 w-full p-1">
                                <Link href={`/mag/${ConvertLink(article.article_url)}`} className="relative m-1 h-[300px] w-full block text-center">
                                    <Image
                                        alt={article.article_image_alt || article.article_title}
                                        src={imageUrl + article.article_image}
                                        fill
                                        className="object-cover rounded"
                                    />
                                    <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex flex-col items-center text-xl font-bold rounded-md bg-white text-text bg-opacity-80 p-2 w-[90%]">
                                        <p className="text-sm font-bold break-words">{article.article_title}</p>
                                        <p className="text-sm break-words">رمان برای مطالعه {PersianNum(article.article_time_read ? Number(article.article_time_read) : 5)} دقیقه</p>
                                    </div>
                                </Link>
                            </div>
                        )
                    }
                </div>
                <PaginationView total={data?.data?.count} url="" />
            </div>
        </div>
    )
}

export default BlogView